/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_LanguageWithLevel = {
    language: string;
    level: employees_LanguageWithLevel.level;
};
export namespace employees_LanguageWithLevel {
    export enum level {
        MOTHER_TONGUE = 'mother_tongue',
        GOOD = 'good',
        BASIC = 'basic',
    }
}

